export const useAlternates = () => ({
  alternates: useState<Array<{ locale: string; url: string }> | null>(
    'alternates',
    () => null
  ),
  shopPath: useState<string | null>('shopPath', () => null),
})
